<template>
  <div>
      <div class="head">
        <div class="title">
          <div >
            <div style="margin-right:10px">类 型</div>
              <el-select v-model="mapType" filterable placeholder="请选择" clearable >
                <el-option
                  v-for="item in mapTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
          </div>
          <div>
            <div style="margin-right:10px">标 题</div>
            <el-select v-model="title" filterable placeholder="请选择" clearable >
              <el-option
                v-for="item in titles"
                :key="item.id"
                :label="item.title"
                :value="item.title">
              </el-option>
            </el-select>
          </div>
          <div class="mybtn">
            <el-button type="primary" size="mediun" icon="el-icon-search" @click="search">搜 索</el-button>
            <el-button size="mediun" type="success" icon="el-icon-document-copy" @click="simulationRecord">
              预演记录</el-button>
            <el-button size="mediun" type="success" icon="el-icon-document-copy" @click="handleRecord">操作记录</el-button>
            <el-button  type="primary" size="mediun" icon='el-icon-circle-plus-outline' @click="addMap" v-if="usertype==1">新 增</el-button>
          </div>
          <!-- <div>
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div> -->
        </div>
      </div>
      <div class="content">
        <div class="userlist-content"   ref="myHeight">
          <el-table
            :data="tableData"
            tooltip-effect="dark"
            @row-dblclick="clickRow" 
            >
            <el-table-column prop="title" label="标题"  align='center' ></el-table-column>
            <el-table-column prop="name" label="类型"  align='center' ></el-table-column>
            <el-table-column prop="creattime" label="创建时间"  align='center'></el-table-column>
            <el-table-column prop="updatetime" label="修改时间" align='center'></el-table-column>
            <el-table-column prop="userName" label="创建人" align='center' width='100'></el-table-column>
            <!-- <el-table-column prop="reviserName" label="修改人" align='center' width='100'></el-table-column> -->
            <el-table-column label="操作"  align='center' width='400'>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-edit-outline"
                  type="success"
                  @click="seeMap(scope.$index, scope.row)"
                >查看</el-button>
                <el-button
                  size="mini"
                  icon="el-icon-edit-outline"
                  type="primary"
                  v-if="usertype==1"
                  @click="handleEdit(scope.$index, scope.row)"
                >修改</el-button>
                <el-button
                  size="mini"
                  icon="el-icon-edit-outline"
                  type="danger"
                  v-if="usertype==0"
                  @click="operate(scope.$index, scope.row)"
                >操作</el-button>
                <el-button
                  size="mini"
                  icon="el-icon-edit-outline"
                  type="primary"
                   v-if="usertype==1"
                  @click="addLogic(scope.$index, scope.row)"
                >添加逻辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  v-if="usertype==1"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
                <el-button
                  size="mini"
                  type="warning"
                  icon="el-icon-data-analysis"
                  v-if="usertype==0"
                  @click="simulation(scope.$index, scope.row)"
                >模拟预演</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
    </div>
    <div class="mydialog">
      <el-dialog title="操作记录" :visible.sync="dialogTableVisible" width='850px'>
        <div class="operatehead">
          <div>
              <el-date-picker
                v-model="operateDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
          </div>
          <div>
              <el-select v-model="operateUser" filterable placeholder="请选择操作人" clearable >
                <el-option
                  v-for="item in operateUsers"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
          </div>
          <div>
            <el-input placeholder="请输入操作内容" v-model="operateContent" clearable></el-input>
          </div>
          <div>
            <el-button type="primary" @click="searchRecord">搜索</el-button>
          </div>
        </div>
        <el-table :data="recordData" max-height="500">
          <el-table-column property="updatetime" label="时间" align='center' width='150'></el-table-column>
          <el-table-column property="name" label="姓名" align='center' width='100'></el-table-column>
          <el-table-column property="type" label="类型" align='center' :formatter="changeTypeList" width='100'></el-table-column>
          <el-table-column property="recordcontent" label="操作内容" align='center'></el-table-column>
        </el-table>
        <div class="pagination">
              <el-pagination
                @size-change="changeRecordSize"
                @current-change="changeRecordIndex"
                :page-sizes="[10, 20]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="recordTotal">
              </el-pagination>
        </div>
      </el-dialog>
    </div>
    <div class="mysimulate">
      <el-dialog title="预演记录" :visible.sync="simulateDialog" width='850px'>
        <el-dialog
            width="50%"
            title="模拟预演记录详情"
            :visible.sync="innerVisible"
            append-to-body
            center>
            <div class="myheight"> 
              <el-table
                :data="simulateInfo"
                tooltip-effect="dark" >
                <el-table-column prop="time" label="时间"  align='center' width='150'></el-table-column>
                <el-table-column prop="content" label="操作内容"  align='center'></el-table-column>
                <el-table-column prop="tips" label="操作提示" align='center' width='200'></el-table-column>
              </el-table>
            </div>
        </el-dialog>
        <!-- <div class="myselect">
          <span class="demonstration" style="margin:0 10px">时间范围</span>
          <el-date-picker
            v-model="simulateTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <span style="margin-left:50px"></span>
          <el-button
              size="mini"
              icon="el-icon-edit-outline"
              type="primary"
              @click="getSimulateByTime"
            >确定</el-button>
        </div> -->
        <div class="operatehead " >
          <div>
            <el-date-picker
              v-model="simulateDate"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </div>
          <div>
              <el-select v-model="simulateUser" filterable placeholder="请选择操作人" clearable >
                <el-option
                  v-for="item in simulateUsers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
          </div>
          <div>
            <el-input placeholder="请输入标题" v-model="sRecord" clearable></el-input>
          </div>
          <div>
            <el-button type="primary" @click="searchSimulateRecord">搜索</el-button>
          </div>
        </div>
        <el-table :data="simulateRecordData" max-height="500" >
          <el-table-column property="createtime" label="开始时间" align='center' :formatter="changeCreateTime" width='150'></el-table-column>
          <el-table-column property="endtime" label="结束时间" align='center'  :formatter="changeTime" width='150'></el-table-column>
          <el-table-column property="userName" label="操作人" align='center'></el-table-column>
          <el-table-column property="guarder" label="监护人" align='center'></el-table-column>
          <el-table-column property="title" label="标题" align='center' width='150'></el-table-column>
          <el-table-column label="详情" align='center'>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-edit-outline"
                  type="primary"
                  @click="getRecordDetail(scope.$index, scope.row)"
                >查看</el-button>
              </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
              @size-change="changeSize"
              @current-change="changeIndex"
              :page-sizes="[10, 20]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="simulateTotal">
            </el-pagination>
        </div>
      </el-dialog>
    </div>
    <div class="simulatedialog">
      <el-dialog
        title="提示"
        :visible.sync="simulatedialogVisible"
        width="30%"
        :before-close="handleClose">
        <div>
          <el-form :model="ruleForm" :rules="simulaterules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="预演标题" prop="title">
              <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="操作人" prop="userName">
              <el-input v-model="ruleForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="监护人" prop="guarder">
              <el-input v-model="ruleForm.guarder"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="simulateBtn">
                <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
                <el-button @click="resetForm('ruleForm')">取消</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>  
  </div>
</template>
<script>
import {formatDate} from '../utils/utils'
export default {
    data () {
      return {
        ruleForm:{
          title:"",
          userName:"",
          guarder:""
        },
        titles:[],
        title:"",
        tableData:[],
        searchObj:{
          type:"",
          title:"",
          pageindex:1,
          pagesize:10
        },
        usertype:"",
        dialogTableVisible:false,
        simulatedialogVisible:false,
        recordData:[],
        total:0,
        typeList:["修改记录","操作记录"],
        recordTypes:[
          {recordType:"修改记录",value:1},
          {recordType:"操作记录",value:2}
        ],
        recordType:"",
        searchRecordObj:{
          elemapid:"",
          type:"",
          pageindex:1,
          pagesize:10,
          userid:"",
          updatetime:"",
          recordcontent:''
        },
        elemapid:"",
        simulateTime:"",
        simulateRecordData:[],
        simulateDialog:false,
        simulateTotal:0,
        searchSimulateRecordObj:{
          createtime:'',
          pageindex:1,
          pagesize:10,
          title:'',
          userName:""
        },
        recordTotal:0,
        innerVisible:false,
        simulateInfo:[],
        clientHeight:'',
        simulaterules:{
          title:[{ required: true, message: '请输入标题', trigger: 'blur' }],
          userName:[{ required: true, message: '请输入操作人', trigger: 'blur' }],
          guarder:[{ required: true, message: '请输入监护人', trigger: 'blur' }]
        },
        simulateid:"",//模拟预演图的id
        mapTypes:[],
        mapType:'',
        imageUrl:"",
        operateDate:"",//操作记录日期
        operateUser:"",//操作人
        operateContent:"",
        operateUsers:[],
        simulateDate:"",
        simulateUser:"",
        simulateUsers:[],
        sRecord:"",
     }
   },
    computed:{
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight)
      },
    },
    components:{
    },
    mounted(){
      this.clientHeight =   `${document.documentElement.clientHeight}`-220         
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`-220 ;
      };
      this.usertype=JSON.parse(sessionStorage.getItem('userinfo')).type
      // this.getInfo()
      this.getMap();
      this.getUser();
      this.getAllMapType()
    },
    methods:{
      //查看模拟图
      seeMap(index,row){
        //不进行任何操作
         this.$router.push({name:'makeMap',params:{id:row.id,type:6,mapName:row.title}})
         //console.log(row.id)
      },
      //点击行 查看模拟图
      clickRow(row){
        //console.log(row)
        this.$router.push({name:'makeMap',params:{id:row.id,type:6,mapName:row.title}})
      },
      //获取所有的模拟图类型
      getAllMapType(){
        this.$api.getAllMapType({},res=>{
          this.mapTypes=res.data
        })
      },
      handleAvatarSuccess(res, file) {
          // //console.log(res,file)
        this.imageUrl = URL.createObjectURL(file.raw);
        // //console.log(this.imageUrl)
      },
      //新增模拟图
      addMap(){
        this.$router.push({name:'makeMap'})
      },
      changeFixed(clientHeight){ //动态修改样式
        this.$refs.myHeight.style.maxHeight = clientHeight+'px';
      },
      changeRecordSize(val){
        this.searchRecordObj.pagesize=val;
        this.handleRecord()
      },
      changeRecordIndex(val){
        this.searchRecordObj.pageindex=val;
        this.handleRecord()
      },
      //按时间获取预演记录
      getSimulateByTime(){
        if(this.simulateTime){
          this.searchSimulateRecordObj.begindate=this.simulateTime[0].Format("yyyy-MM-dd hh:mm");
          this.searchSimulateRecordObj.enddate=this.simulateTime[1].Format("yyyy-MM-dd hh:mm");
        }else{
          this.searchSimulateRecordObj.begindate='';
          this.searchSimulateRecordObj.enddate='';
        }
        this.simulationRecord()
      },
      //修改预演记录页数
      changeSize(val){
         this.searchSimulateRecordObj.pagesize=val;
         this.simulationRecord()
      },
      //修改预演index
      changeIndex(val){
         this.searchSimulateRecordObj.pageindex=val;
         this.simulationRecord()
      },
      //时间格式化
      changeTime(val){
        if(val.endtime){
          return (new Date(val.endtime)).Format("yyyy-MM-dd hh:mm")
        }
      },
      changeCreateTime(val){
        if(val.createtime){
          return (new Date(val.createtime)).Format("yyyy-MM-dd hh:mm")
        }
      },
      //按照id获取预演详情
      getRecordDetail(index,row){
        this.innerVisible=true;
        var id=row.id;
        this.$api.getSimulationRecord({id:row.id},res=>{
          if(res.errCode==0){
            //console.log(res.data.list)
            this.simulateInfo=JSON.parse(res.data.list[0].content)
          }
          // this.simulateInfo.forEach(v=>{
          //   v.content=JSON.parse(v.content)
          // })
        })
      },
      //按类型查看记录
      selectRecordType(e){
        //console.log(e)
        if(e){
          this.searchRecordObj.type=e;
          this.searchRecordObj.elemapid=this.elemapid;
          this.searchRecordObj.pageindex=1;
          this.$api.getRecordInfo(this.searchRecordObj,res=>{
            //console.log(res)
            if(res.errCode==0){
              this.recordData=res.data
            }
          })
        }else{
          this.searchRecordObj.elemapid=this.elemapid;
          this.searchRecordObj.type="";
          this.searchRecordObj.pageindex=1;
          this.$api.getRecordInfo(this.searchRecordObj,res=>{
            //console.log(res)
            if(res.errCode==0){
              this.recordData=res.data
            }
          })
        }
      },
      //格式化记录类型
      changeTypeList(val){
        // //console.log(val)
        return this.typeList[val.type-1]
      },
      //添加逻辑
      addLogic(index,row){
         this.$router.push({name:'makeMap',params:{id:row.id,type:4,mapName:row.title}})
      },
      //搜索
      search(){
        this.searchObj.type=this.mapType;
        this.searchObj.title=this.title;
        this.getMap()
      },
      //修改
      handleEdit(index,row){
        this.$router.push({name:'makeMap',params:{id:row.id,type:1,mapName:row.title}})
      },
      //操作
      operate(index,row){
        this.$router.push({name:'makeMap',params:{id:row.id,type:3,mapName:row.title}})
      },
      //删除
      handleDelete(index,row){
        //console.log(row.id,'rowrow')
        //console.log(this.tableData,'tableData')
        
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.deleteMap({id:row.id},res=>{
            if(res.errCode==0){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getMap()
              this.$api.delComponent({mapid:row.id},res=>{
                if(res.errCode==0){
                  this.deleteMapLogic(row.id)
                }
              })
            }else{
              this.$message.error("删除失败!");
            }
          })
        })
      },
      //删除图，同时删除对应此图的逻辑
      deleteMapLogic(id){
        let _this=this
        
         this.$api.getcomponentlist({pagesize:9999},res=>{
          res.data.list.forEach(item=>{

            if(item.logicOn&&JSON.parse(item.logicOn).length>0){
                  var arr = JSON.parse(item.logicOn).filter((v)=>{
                    return v.mapid!=id
                  })
                
                  item.logicOn=JSON.stringify(arr)
                  _this.$api.changecom({nodedata:item},res=>{
            
                  })
            }

            if(item.logicOff&&JSON.parse(item.logicOff).length>0){
                  var a = JSON.parse(item.logicOff).filter((v)=>{
                    return v.mapid!=id
                  })
                
                  item.logicOff=JSON.stringify(a)
                  _this.$api.changecom({nodedata:item},res=>{
            
                  })
            }

            if(item.logicChoice2&&JSON.parse(item.logicChoice2).length>0){
                  var carr = JSON.parse(item.logicChoice2).filter((v)=>{
                    return v.mapid!=id
                  })
                
                  item.logicChoice2=JSON.stringify(carr)
                  _this.$api.changecom({nodedata:item},res=>{
            
                  })
            }
            
          })
        })
    },
    updateMapInfo(id,nodedata){
      let params = {
          id: id,
          nodedata: JSON.stringify(nodedata),
        };
     
        this.$api.deleteNode(params, res => {
          //console.log(res, "resres");
         
        });
    },
      // 操作、修改记录
    handleRecord(){
      this.dialogTableVisible=true;
      this.$api.getRecordInfo(this.searchRecordObj,res=>{
        //console.log(res)
        if(res.errCode==0){
          this.recordData=res.data;
          this.recordTotal=res.maxCount;
        }
      })
    },
      //点击预演按钮
      simulation(index,row){
        //type=2 进行模拟预演
        this.simulateid=row.id
        this.simulatedialogVisible=true;
      },
      //确定进行预演
      submitForm(formName) {
        var params={
          title:this.ruleForm.title,
          userName:this.ruleForm.userName,
          guarder:this.ruleForm.guarder,
          createtime:new Date().Format("yyyy-MM-dd hh:mm"),
          id:this.simulateid,
          type:2
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            this.$router.push({name:'makeMap',params:params})
          } else {
            // //console.log('error submit!!');
            return false;
          }
        });
      },
      //取消预演
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.simulatedialogVisible=false
      },
      //取消预演  点击X关闭
      handleClose(){
        this.simulatedialogVisible=false;
      },
      //预演记录
      simulationRecord(){
        this.simulateDialog=true;
        this.$api.getSimulationRecord(this.searchSimulateRecordObj,res=>{
          //console.log(res)
          if(res.errCode==0){
            this.simulateRecordData=res.data.list;
            this.simulateTotal=res.data.allnum;
          }
        })
      },
      //获取模拟图信息
      getMap(){
        this.$api.getMapInfo(this.searchObj,res=>{
          //console.log(res)
          if(res.errCode==0){
            this.total=res.data.allnum
            res.data.list.forEach(m=>{
                m.creattime= new Date(m.creattime).Format("yyyy-MM-dd hh:mm")
                m.updatetime= new Date(m.updatetime).Format("yyyy-MM-dd hh:mm")
            })
            this.tableData=res.data.list
            this.titles=res.data.list
          }
        })
      },
      //获取用户信息
      getUser(){
        this.$api.getmanageuserlist({},res=>{
          //console.log(res)
          if(res.errCode==0){
            this.writers=res.data.list
            this.operateUsers=res.data.list
            this.simulateUsers=res.data.list
          }
        })
      },
      //切换页面数据
      handleSizeChange(val){
        this.searchObj.pagesize=val;
        this.getMap()
      },
      //翻页
      handleCurrentChange(val){
        this.searchObj.pageindex=val;
        this.getMap()
      },
      //搜索操作记录
      searchRecord(){
        this.searchRecordObj.userid=this.operateUser;
        this.searchRecordObj.updatetime=this.operateDate;
        this.searchRecordObj.recordcontent=this.operateContent;
        this.handleRecord()
      },
      //搜索预演记录
      searchSimulateRecord(){
        this.searchSimulateRecordObj.createtime=this.simulateDate
        this.searchSimulateRecordObj.title=this.sRecord
        this.searchSimulateRecordObj.userName=this.simulateUser
        // //console.log(this.simulateUser)
        this.simulationRecord()
      },
    }
}

</script>
<style scoped>
.content /deep/ .el-table__row{
  cursor: pointer;
}
.operatehead{
  display: flex;
  /* cursor: pointer; */
}
.operatehead>div{
 width: 200px;
 margin-right: 10px;
}
.operatehead>div:first-child{
  margin-right: 30px;
  /* width:280px; */
  /* width: 150px; */
}
.simulateRecord>div:first-child{
    margin-right: 30px;
  width:280px;
}
.operatehead>div:last-child{
  /* margin-right: 30px; */
  text-align: right;
}
.simulateRecord>div:last-child{
  /* margin-right: 30px; */
  /* text-align: right; */
  margin-left: 75px;
}
.myheight{
  max-height: 400px;
  overflow-y: auto;
}
.simulateInfo{
  margin-bottom: 10px;
}
.demonstration{
  display: inline-block;
  line-height: 40px;
  font-size: 16px;
}
.mysimulate /deep/ .el-dialog__header {
  padding-bottom: 0px;
}
.mysimulate /deep/ .el-dialog__body {
  padding-top: 15px;
}
.mydialog /deep/ .el-dialog__header {
  padding-bottom: 0px;
}
.mydialog /deep/ .el-dialog__body {
  padding-top: 15px;
}
.myselect{
  display: flex;
  margin-bottom: 10px;
}
.simulatedialog /deep/ .el-input{
  width: 250px;
}
 .simulatedialog /deep/ .el-dialog__body{
  margin-left: auto;
  margin-right: auto;
}
.simulatedialog /deep/ .el-form-item__content{
  display: flex;
}
.simulateBtn{
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.myselect>div:first-child{
  line-height: 40px;
  margin-right: 10px;
  font-size: 16px;
}
.userlist-content{
  width: 100%;
  overflow: auto;
}
.head{
  width: 95%;
  margin-bottom: 20px;  
  padding-top: 15px;
  color: #666;
  margin: 0 auto;
}
.title{
  width: 100%;
  height:60px;
  font-size: 14px;
  line-height: 60px;
  /* font-weight: bold; */
  display: flex;
  margin:0 auto;

}
.title>div{
  display: flex;
  margin-left: 20px;
 
}
.mybtn{
  height: 36px;
  /* margin-top: 15px; */
  margin-left: 60px !important;
  display: block !important;
}
.content{
  width:95%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}
.pic{
  width:50%;
  height: 200px;
  cursor: pointer;
  display: flex;
  margin-bottom:20px;
 
}
.myimg{
  width: 300px;
  height: 200px;
  /* margin-left: 5%;
  margin-bottom: 5px; */
}
.btn{
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 14px;
  line-height: 30px;
  margin-left: 10px;
  color: #666;
  font-family: verdana;
  
}
.edi{
  display: flex;
}
.pagination{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/mapList.vue